import { computed, reactive } from 'vue'
import { AUTH_STORAGE_TOKEN } from '@/core/constants/auth.constants'

import { useStorage } from 'vue-composable'
const { storage } = useStorage(AUTH_STORAGE_TOKEN)

import { http } from '@/core/realisations/Http.realisation'
import { AuthStateT } from '@/core/types/auth.types'

import { resetImpersonate } from '@/common/composable/useImpersonate'

import useFirebase from './useFirebase'

const AUTH_STATE = reactive({
    access_token: null as string | null,
    refresh_token: null as string | null,
    token_type: null as string | null,
    expires_in: null as number | null,
})

export default function () {
    const firebase = useFirebase()

    function setAuthorization(authorization: AuthStateT) {
        AUTH_STATE.access_token = authorization.access_token
        AUTH_STATE.refresh_token = authorization.refresh_token
        AUTH_STATE.token_type = authorization.token_type
        AUTH_STATE.expires_in = authorization.expires_in

        storage.value = JSON.stringify(AUTH_STATE)
        http.setAuthorization(authorization.access_token, authorization.token_type)

        firebase.initialize()
    }

    function removeAuthorization() {
        AUTH_STATE.access_token = null
        AUTH_STATE.refresh_token = null
        AUTH_STATE.token_type = null
        AUTH_STATE.expires_in = null

        storage.value = ''
        resetImpersonate()
        http.removeAuthorization()
    }

    function initialize() {
        if (!storage.value) return

        if (typeof storage.value === 'object') {
            const authorization: AuthStateT = storage.value
            setAuthorization(authorization)
        }
    }

    const authenticated = computed(() => Boolean(AUTH_STATE.access_token))

    return {
        state: AUTH_STATE,
        authenticated,
        setAuthorization,
        removeAuthorization,
        initialize,
    }
}
